import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { CopyToClipboard } from "Components/Shared/CopyToClipboard";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.PaymentGateways.Secret;

type Props = {
  isOpen: boolean;
  title: string;
  clientID: string;
  clientSecret: string;
  onClose: () => void;
};

const CredentialRow = ({ label, value }: { label: string; value: string }) => {
  const { t } = useResource();

  return (
    <Stack>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography
          variant="body1"
          fontWeight={500}
          sx={{ wordBreak: "break-all", fontFamily: "monospace" }}
        >
          {value}
        </Typography>
        <CopyToClipboard
          text={value}
          accessibilityLabel={label}
          successMessage={t(RESOURCES.Copied)}
        />
      </Stack>
    </Stack>
  );
};

export const GatewaySecretDialog = ({
  isOpen,
  title,
  clientID,
  clientSecret,
  onClose,
}: Props) => {
  const { t } = useResource();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack gap={3}>
          <Alert severity="warning">{t(RESOURCES.Warning)}</Alert>
          <CredentialRow label={t(RESOURCES.ClientID)} value={clientID} />
          <CredentialRow
            label={t(RESOURCES.ClientSecret)}
            value={clientSecret}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          {t(RESOURCES.Close)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
